import { registerQuery } from 'data-fetching-client';
import { getModuleDetailsPreview } from '../../clients/ecosystemClient';
function getModuleDetailsPreviewData({
  offeringId
}) {
  return getModuleDetailsPreview(offeringId);
}
export const GET_MODULE_DETAILS_PREVIEW = registerQuery({
  fieldName: 'detailsPreview',
  args: ['offeringId'],
  fetcher: getModuleDetailsPreviewData
});